import { useState } from "react";
import { Popover } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import OtSecurityCustomFilters from "./OtSecurityCustomFilters";
import {
  ColumnsButton, ExportCsvButton, FilterButton, GridToolbarBar, ToolbarDivider,
  ToolbarGroup, ToolbarSpacer, VisibilityToggle,
} from "./ToolbarKit";

const OtSecurityToolBar = ({ filterModel, setFilterModel, hideAcked, setHideAcked }) => {
  const [anchor, setAnchor] = useState(null);
  const [openCount, setOpenCount] = useState(0);

  const handleOpen = (e) => {
    setAnchor(e.currentTarget);
    setOpenCount((c) => c + 1);
  };

  return (
    <GridToolbarBar>
      <ToolbarGroup>
        <ColumnsButton />
        <FilterButton count={filterModel.length} onClick={handleOpen} />
      </ToolbarGroup>

      {setHideAcked && (
        <>
          <ToolbarDivider />
          <ToolbarGroup>
            <VisibilityToggle
              label="ACK'd"
              icon={CheckCircleOutlineIcon}
              visible={!hideAcked}
              onToggle={() => setHideAcked(!hideAcked)}
              description="Events already acknowledged"
            />
          </ToolbarGroup>
        </>
      )}

      <ToolbarSpacer />
      <ExportCsvButton />

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: { p: 1 } } }}
      >
        <OtSecurityCustomFilters
          key={openCount}
          filterModel={filterModel}
          setFilterModel={setFilterModel}
          onClose={() => setAnchor(null)}
        />
      </Popover>
    </GridToolbarBar>
  );
};

export default OtSecurityToolBar;
